import httpService from "services/api.service";

const BASE_URL = "/dashboard_report";

export const getDashboard = async (payload) => {
  try {
    const res = await httpService.get(BASE_URL, { params: payload });
    return res;
  } catch (error) {
    throw error.message;
  }
};
